module.exports = __webpack_public_path__ + "img/acacia_mweya4.0b10c658.jpeg";